import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import '../../../../reports/payment-video.css'
import { TutorialVideoLink } from '../../../../../tenant/TutorialVideoLink'
const UsersListHeader: React.FC = () => {
  const intl = useIntl()
  const [showVideoHighlight, setShowVideoHighlight] = useState(false)

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some(item => item.trim().startsWith('users_page_video='));

    setShowVideoHighlight(!hasSeenVideo);
  }, []);

  return (
    <div className='card-header border-0 pt-5 d-flex justify-content-between align-items-start'>
      <h3 className='card-title align-items-start flex-column mb-0'>
        <span className='card-label fw-bolder fs-3 mb-1'>
          {intl.formatMessage({id: 'USERS.PAGE_TITLE'})}
        </span>
        <span className='text-muted mt-1 fw-bold fs-7'>
          {intl.formatMessage({id: 'USERS.PAGE_DESCRIPTION'})}
        </span>
      </h3>

      <TutorialVideoLink
        section="users"
        fallback="https://www.youtube.com/watch?v=U1DGI2eB7kI"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-primary d-flex align-items-center ${
          showVideoHighlight ? 'video-highlight' : ''
        }`}
        onClick={() => {
          document.cookie = "users_page_video=seen";
          setShowVideoHighlight(false);
        }}
      >
        <i className='fab fa-youtube text-danger fs-2'></i>
        <span className='ms-2'>
          {intl.formatMessage({ id: 'video_link' })}
        </span>
      </TutorialVideoLink>
    </div>
  )
}

export {UsersListHeader}
